import React from 'react';
import { Box } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import ActivityLog from '@/modules/ActivityLog';
import { useHasAccess } from '@/modules/core/hooks';
import ModuleWrapper from '@/modules/plan/ModuleWrapper';

interface Props {
  isPageMode?: boolean;
}

const CopayActivityLog: React.FC<Props> = ({ isPageMode }) => {
  const hasAccess = useHasAccess([{ permission: Permissions.VIEW_COPAY }]);

  if (!isPageMode || !hasAccess) return null;

  return (
    <Box margin={{ top: 'spacing24' }}>
      <ModuleWrapper
        testId="copay-activity-log"
        anchorId="copay-activity-log"
        title="Activity Log"
        expandless
      >
        <ActivityLog />
      </ModuleWrapper>
    </Box>
  );
};

export default React.memo(CopayActivityLog);
